/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The kind of support ticket. Determines which severity scale applies
 * (see !:Compliance.Module.Support.Services.SupportSeverity).
 */
export enum SupportTicketType {
    BUG = 'Bug',
    FEATURE_REQUEST = 'FeatureRequest',
    SYSTEM_OUTAGE = 'SystemOutage',
}
